<div class="collection-license-selector"
     [class.tablet]="deviceService.isTablet()"
     [class.mobile]="deviceService.isMobile()">
  <div class="step-title"  *ngIf="isMultiLicense">
    {{ 'collections.collection-license-selector.title' | translate }}
  </div>
  <div class="license-blocks"
       *ngIf="!isAuthor"
       [class.scroll]="!deviceService.isDesktop()">
    <div class="license-block"
         *ngFor="let license of licenses; trackBy: trackByFn">
      <div>
        <div class="license-option" *ngIf="hasLicensePersonal">
        <app-icon
          class="license-icon"
          [icon]="'billing-done'"
          [width]="20"
          [height]="20">
        </app-icon>
        <div class="text-block">
          <span class="text-title">{{ 'collection-license.personal' | translate }}</span>
          <span
            class="text-description">{{ 'collections.collection-license-selector.description-personal' | translate }}</span>
        </div>
      </div>
        <div class="license-option" *ngIf="hasLicenseProfessional && license!==collectionLicenseEnum.personal">
        <app-icon
          class="license-icon"
          icon="billing-done"
          [width]="20"
          [height]="20">
        </app-icon>
        <div class="text-block" [class.with-opacity]="license === collectionLicenseEnum.personal">
          <span class="text-title">{{ 'collection-license.professional' | translate }}</span>
          <span
            class="text-description">{{ 'collections.collection-license-selector.description-professional' | translate }}</span>
        </div>
      </div>
        <div class="license-option" *ngIf="hasLicenseBusiness && license===collectionLicenseEnum.business">
        <app-icon
          class="license-icon"
          icon="billing-done"
          [width]="20"
          [height]="20">
        </app-icon>
        <div class="text-block" [class.with-opacity]="license !== collectionLicenseEnum.business">
          <span class="text-title">{{ 'collection-license.business' | translate }}</span>
          <span
            class="text-description">{{ 'collections.collection-license-selector.description-business' | translate }}</span>
        </div>
      </div>
      </div>

      <div>
        <div class="price-block">
        <ng-template [ngIf]="collection.discount">
          <div class="old-price">
          <span class="price-without-discount">
            {{ getFormattedPrice(collection.price_tiers[license], collection.discount) | async }}
          </span>
            <span class="discount">
          {{ 'collections.collection-license-selector.discount' | translate : {'discount': collection.discount} }}
        </span>
          </div>
        </ng-template>
        <span class="current-price">
          {{ getFormattedPrice(collection.price_tiers[license]) | async }}
        </span>
      </div>
        <div class="action-block">
        <on-ui-button *ngIf="!isPurchasedLicence(license)"
                      class="primary outline"
                      label="collections.collection-license-selector.action-pay"
                      (onclick)="onPay(license)">
        </on-ui-button>
        <on-ui-button *ngIf="isPurchasedLicence(license)"
                      class="primary outline"
                      [disabled]="true"
                      label="collections.collection-license-selector.already-use">
        </on-ui-button>
      </div>
      </div>
    </div>
  </div>

  <div *ngIf="isAuthor" class="author-message-block">
    {{ 'collections.collection-license-selector.cannot-buy' | translate }}
  </div>
</div>
